import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// Used by content
import "HSNDIR/BonusBuy.js";

/**
* class HSN.BonusBuyModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.BonusBuyModal = (function (parent) {
    __extends(BonusBuyModal, parent);
        
    function BonusBuyModal(config) {
        var modal = BonusBuyModal.__super__.constructor.call(this, "bonusbuy");

        this.callbackok = null;
        this.callbackcancel = null;

        this.Close.off();//remove existing handler, have our own

        eventHandlers(this);

        var loader = $('<div id="loader" class="loader"><img alt="" src="/assets/img/spinner-l-d8d9d9.gif"></div>');
        loader.appendTo(this.Root);

        return modal;
    }

    function eventHandlers(modal) {

        /*$(modal.Content).on('click', '#baseball-card-modal', function (e) {
            $(this).off('click');
            $(modal.Close).click();
            return false;
        });*/

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        $('.video-flash').css('visibility', 'visible');

        modal.Hide();

        //cmCreateManualLinkClickTag('cm_re=cm_re=Arcade-_-Profile-_-Close&cm_sp=cm_re=Arcade-_-Profile-_-Close', 'CloseArcadeDrawer');
    }

    callbackok: null;
    callbackcancel: null;

    BonusBuyModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    BonusBuyModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    BonusBuyModal.prototype._show = function (id, useQualifiers) {
        $('.video-flash').css('visibility', 'hidden');

        this.Center();

        $.ajax("/bonusbuy/PromotionProducts/" + id + "/" + useQualifiers,
            {
                cache: false,
                context: this,
                dataType: 'html',
                success: function (data, status, xhr) {
                    var __scope = this;
                    __scope.Root.removeClass('loading');

                    if (data != null && data != "") {
                        this.Content.showHtml(
                            data,
                            0,
                            function () {
                                __scope.Center();
                                __scope.Content.animate({ opacity: 1 });
                                //handle any tooltips loaded
                                if (!Modernizr.touchevents) {
                                    HSN.Tooltip(__scope.Content.find("[data-tooltip]"));
                                }
                            },
                            function () {
                                //__scope.Center();
                            }
                        );
                    }
                    else {
                        $('#modal-mask').remove();
                    }
                },
                error: function (xhr, status, error) {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    };

    return BonusBuyModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/BonusBuyModal.js